export default {
  FETCH_OFFERS_PROGRESS: 'FETCH_OFFERS_PROGRESS',
  FETCH_COUPONS_AND_OFFERS_SUCCESS: 'FETCH_COUPONS_AND_OFFERS_SUCCESS',
  FETCH_COUPONS_AND_OFFERS_FAILED: 'FETCH_COUPONS_AND_OFFERS_FAILED',
  FETCH_COUPON_DESCRIPTION_INIT: 'FETCH_COUPON_DESCRIPTION_INIT',
  FETCH_COUPON_DESCRIPTION: 'FETCH_COUPON_DESCRIPTION',
  FETCH_COUPON_DESCRIPTION_ERROR: 'FETCH_COUPON_DESCRIPTION_ERROR',
  FETCH_COLLECT_COUPON_INIT: 'FETCH_COLLECT_COUPON_INIT',
  FETCH_COLLECT_COUPON: 'FETCH_COLLECT_COUPON',
  REFRESH_COUPONS: 'REFRESH_COUPONS',
  FETCH_COLLECT_COUPON_ERROR: 'FETCH_COLLECT_COUPON_ERROR',
  FETCH_DECOLLECT_COUPON: 'FETCH_DECOLLECT_COUPON',
  TOGGLE_COLLECT_CARD: 'TOGGLE_COLLECT_CARD',
  TOGGLE_DETAILS_STATUS: 'TOGGLE_DETAILS_STATUS',
  SET_IS_BESTPRICE: 'SET_IS_ESTPRICE',
};
